// Module
var code = "<md-button class=\"abm-qr-scanner md-icon-button\" aria-label=\"Scan QR Code\" abm-qr-scanner> <md-icon class=\"material-icons\" md-svg-src=\"img/qrcode-scan.svg\"></md-icon> </md-button> ";
// Exports
module.exports = code;